import type { JSX } from 'react';
import type { WireActivityItem } from '@logistics/contracts';
import { clockTime, monthDay } from '@/lib/format';
import { activityGlyph } from '@/lib/glyphs';
import { glyphTile } from '../shell/look';
import { typeLook } from './activity-types';

/**
 * One row of the log. `text` can quote a provider or a sender, so it is only
 * ever rendered as a text node — React escapes it.
 */
export function ActivityRow({ item }: { item: WireActivityItem }): JSX.Element {
  const type = typeLook(item.type);
  return (
    <div className="border-line grid min-w-[620px] grid-cols-[110px_34px_minmax(0,1fr)_90px] items-center gap-3.5 border-b px-5 py-3 last:border-b-0">
      <span className="text-mute font-mono text-xs">
        {monthDay(item.at)} {clockTime(item.at)}
      </span>
      <span className={glyphTile}>{activityGlyph(item)}</span>
      <span className="text-[13.5px] [overflow-wrap:anywhere]">{item.text}</span>
      <span className="text-right font-mono text-[11px]" style={{ color: type.color }}>
        {type.label}
      </span>
    </div>
  );
}
